import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import { Form, FormikErrors, FormikProps } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { useDropzone } from 'react-dropzone'
import CaptchaProcess from 'src/components/Captcha/CaptchaProcess'
import DocumentPreview from 'src/components/Document/DocumentPreview'
import Input from 'src/components/Fields/Input'
import { fileToBase64 } from 'src/utils/file'
import request from 'superagent'

export interface IMandatFields {
  clientInfo?: {
    firstname: string
    lastname: string
    num_client: number
    denomination: string
    adresse: string
    codePostal: string
    localite: string
    pays: string
    mobile: string
    email: string
    depot: string
    dateFermeture: string | null
    siret: string
    createdAt: string
    updatedAt: string
  }
  sepaAccepted?: boolean
  firstname?: string
  lastname?: string
  iban?: string
  bic?: string
  ribUrl?: string | null
  captchaValidation?: boolean
}

interface MandatFormProps extends FormikProps<IMandatFields> {
  errors: FormikErrors<IMandatFields>
  errorsServer: Array<{
    message?: string
  }>
  otherErrors?: any
  value?: any
}

const MandatForm: React.FC<MandatFormProps> = ({
  setFieldValue,
  values,
  setFieldError,
  otherErrors,
  errors,
  touched,
}) => {
  const [captcha, setCaptcha] = useState(true)
  const [fileType, setFileType] = useState<'pdf' | 'image' | undefined>(undefined)
  const [isPending, setIsPending] = useState(false)
  const [isUploded, setIsUploaded] = useState(false)
  const [hasError, setHasError] = useState(false)
  const [fileBase64, setFileBase64] = useState<string | undefined>(undefined)
  const [divHeight, setDivHeight] = useState(190)

  /**
   * UPLOAD
   */
  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/jpeg, application/pdf',
    maxFiles: 2,
    onDrop: async (files) => {
      if (!files.length) return

      setIsPending(true)
      setHasError(false)
      setIsUploaded(true)

      let file = files[0]

      // Vérification du type Blob
      if (!(file instanceof Blob)) {
        console.error("Le fichier sélectionné n'est pas un Blob valide.")
        setHasError(true)
        setIsPending(false)
        return
      }

      try {
        const base64File = await fileToBase64(file)
        setFieldValue('rib', base64File)
        setFileType(file.type === 'application/pdf' ? 'pdf' : 'image')

        const response = await request.post(`${process.env.REACT_APP_API_URL}/auth-mandat/upload-rib`).send({
          fileBase64: base64File,
          fileName: file.name,
          clientId: values.clientInfo?.num_client,
        })

        const { ribUrl } = response.body

        setFileBase64(base64File as string)
        setFieldValue('ribUrl', ribUrl)
        setIsUploaded(true)
      } catch (error) {
        console.error('Erreur lors du traitement du fichier :', error)
        setHasError(true)
      } finally {
        setIsPending(false)
      }
    },
  })

  useEffect(() => {
    if (otherErrors && otherErrors.data && otherErrors.data.captchaValidation) {
      setCaptcha(false)
      setTimeout(function () {
        setCaptcha(true)
      }, 1000)
    }
  }, [otherErrors])

  useEffect(() => {
    if (values.clientInfo) {
      if (values.clientInfo.firstname) {
        setFieldValue('firstname', values.clientInfo.firstname)
      }
      if (values.clientInfo.lastname) {
        setFieldValue('lastname', values.clientInfo.lastname)
      }
    }
  }, [values.clientInfo, setFieldValue])

  const onCaptchaSuccess = () => {
    setFieldValue('captchaValidation', true)
  }

  const setCaptchaError = (message: string) => {
    setFieldError('captchaValidation', message)
  }
  return (
    <Form id="inscription">
      <div id="sepa_fields" className="visible">
        <Input label="Prénom" name="firstname" required />

        <Input label="Nom" name="lastname" required />
        <Input label="IBAN" name="iban" required />
        <Input label="BIC" name="bic" required />
        <Input full type="checkbox" name="sepaAccepted" required>
          En signant ce formulaire de mandat, vous autorisez la société HOUDAN CUISINES S.A.S. à envoyer des
          instructions à votre banque pour débiter votre compte, et votre banque à débiter votre compte conformément aux
          instructions de HOUDAN CUISINES S.A.S
          <br />
          <br />
          <small>
            {' '}
            Vous bénéficiez du droit d'être remboursé par votre banque selon les conditions décrites dans la convention
            que vous avez passée avec elle.
            <br /> Une demande de remboursement doit être présentée :<br /> &nbsp;&nbsp;&nbsp;&nbsp;- dans les 8
            semaines suivant la date de débit de votre compte pour un prélèvement autorisé,
            <br /> &nbsp;&nbsp;&nbsp;&nbsp;- sans tarder et au plus tard dans les 13 mois en cas de prélèvement non
            autorisé.
            <br /> Vos droits concernant le présent mandat sont expliqués dans un document que vous pouvez obtenir
            auprès de votre banque.{' '}
          </small>
        </Input>
      </div>
      <div
        {...getRootProps()}
        style={{
          border: '1px solid #d22630',
        }}
        className=" h-9/10 flex flex-col m-auto w-full justify-center items-center text-center p-6"
      >
        {(hasError || !isUploded) && (
          <input {...getInputProps()} name="rib" type="file" accept=".pdf, .jpeg" required className="underline" />
        )}
        <p>Dépôt du RIB*</p>
        {fileBase64 && <DocumentPreview fileUrl={fileBase64} fileType={fileType} />}
        {isUploded && !hasError && !isPending && (
          <>
            <p style={{ color: 'rgb(38, 210, 60)' }}>Merci, votre document est déposé avec succès</p>

            <button
              onClick={() => {
                setIsUploaded(false)
                setFileBase64(undefined)
                setFileType(undefined)
              }}
              style={{
                marginTop: '10px',
                padding: '8px 12px',
                backgroundColor: '#d22630',
                color: '#ffffff',
                border: 'none',
                cursor: 'pointer',
                borderRadius: '4px',
              }}
            >
              Modifier le fichier
            </button>
          </>
        )}
      </div>
      {hasError && <div style={{ color: 'rgb(210, 38, 48)', textAlign: 'center' }}>{hasError}</div>}
      <div className="mx-auto mt-3">
        <div className="field full">
          {captcha && values.captchaValidation !== true && (
            <CaptchaProcess onSuccess={onCaptchaSuccess} setError={setCaptchaError} />
          )}
          {touched.captchaValidation && errors.captchaValidation && (
            <div style={{ color: 'rgb(210, 38, 48)', textAlign: 'center', marginTop: '8px' }}>
              {errors.captchaValidation}
            </div>
          )}
        </div>
      </div>
    </Form>
  )
}

export default MandatForm
